<template>
  <!--Button-Dialog-Import-->
  <v-dialog v-model="dialogImport" max-width="500px" persistent>
    <template v-slot:activator="{ props }">
      <v-btn
        color="secondary"
        v-bind="props"
        variant="elevated"
        class="text-white mr-1"
      >
        <span>{{ $t("labels.import-flow") }}</span>
      </v-btn>
    </template>
    <v-card>
      <v-toolbar :flat="true" color="secondary">
        <v-toolbar-title class="text-white">
          {{ $t("labels.import-flow") }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn color="white" icon="mdi-close" @click="closeImportFlow"> </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-form
          enctype="multipart/form-data"
          ref="importForm"
          v-model="validation"
          lazy-validation
        >
          <v-row dense>
            <v-col cols="12">
              <div class="text-caption">
                {{ $t("strings.import-info") }}
              </div>
            </v-col>
            <v-col cols="12">
              <p class="text-primary ml-4">
                {{ $t("strings.import-suggest-file") }}
              </p>
              <v-file-input
                v-model="editedItem.file"
                accept="application/json, .zip, .dme"
                color="primary"
                counter
                :label="$t('labels.file-input')"
                :placeholder="$t('strings.select-files')"
                prepend-icon=""
                prepend-inner-icon="mdi-paperclip"
                variant="outlined"
                density="compact"
                :rules="!editedItem.url ? [rules.fileRules] : []"
                :disabled="!!editedItem.url"
                :required="!!editedItem.url"
                show-size
                type="file"
                ref="file"
                name="file"
              >
                <template v-slot:selection="{ fileNames }">
                  <v-chip
                    v-for="fileName in fileNames"
                    :key="fileName"
                    color="primary"
                    label
                    size="small"
                    class="me-2"
                  >
                    {{ fileName }}
                  </v-chip>
                </template>
              </v-file-input>
            </v-col>
            <v-col cols="12">
              <p class="text-primary ml-4">
                {{ $t("strings.import-suggest-url") }}
              </p>
              <v-text-field
                v-model="editedItem.url"
                class="mt-4"
                :label="$t('labels.url')"
                :hint="$t('strings.flow-project-url')"
                :persistent-hint="true"
                variant="outlined"
                :rules="!editedItem.file ? [rules.urlRules] : []"
                :required="!!editedItem.file"
                name="url"
                density="compact"
                :disabled="!!editedItem.file"
                :clearable="true"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary darken-1" variant="text" @click="closeImportFlow">
          {{ $t("labels.cancel") }}
        </v-btn>
        <v-btn
          color="secondary darken-1"
          variant="text"
          :disabled="!validation"
          @click="importFlowConfirm"
          >{{ $t("labels.import") }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
  <DialogImportDependencies
    :dialogDependencies="dialogDependencies"
    :dependenciesList="dependenciesList"
    @activateDialogDependencies="dialogDependencies = $event"
    @dependenciesActions="editedItem.dependencies = $event"
  />
</template>

<script>
import axios from "axios";
import events from "@/mixins/events.js";
import utils from "@/mixins/utils.js";
import DialogImportDependencies from "@/components/DialogImportDependencies.vue";
export default {
  name: "DialogImport",
  components: { DialogImportDependencies },
  mixins: [utils, events],
  emits: ["activateSnackbar"],
  props: ["tenantId", "apiUrl", "refreshList"],
  data: function () {
    return {
      dialogImport: false,
      dialogDependencies: false,
      dependenciesList: [],
      validation: true,
      rules: {
        fileRules: (value) => {
          if (!value) return true; //no files selected
          for (let i = 0; i < value.length; i++) {
            if (value[i].size > 2000000) {
              return this.$t("errors.flow-import-size");
            }
          }
          return true; //all files are less than 2MB
        },

        urlRules: (value) =>
          (!!value &&
            /^(([^:/?#]+):)(\/\/([^/?#]*))([^?#]*)(\?([^#]*))?(#(.*))?/.test(
              value,
            )) ||
          this.$t("errors.flow-url-format"),
      },
      editedItem: {
        file: null,
        url: "",
        dependencies: [],
      },
      defaultItem: {
        file: null,
        url: "",
        dependencies: [],
      },
    };
  },
  methods: {
    importFlowConfirm() {
      if (this.importValidateForm()) {
        this.createFormData();
      }
    },
    //Reading local file
    createFormData() {
      if (!this.editedItem.file && !this.editedItem.url) return;
      const formData = new FormData();
      formData.append("file", this.editedItem.file);
      formData.append("url", this.editedItem.url);
      formData.append(
        "dependencies",
        this.editedItem.dependencies?.errors
          ? JSON.stringify(this.editedItem.dependencies.errors)
          : "",
      );
      this.importFlow(formData);
    },
    closeImportFlow() {
      this.$refs.importForm.resetValidation();
      this.resetDialog();
      this.dialogImport = false;
    },
    importValidateForm() {
      return this.$refs.importForm.validate();
    },
    resetDialog() {
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
      });
    },
    //Import a new flow from file
    importFlow(formData) {
      axios
        .post(this.apiUrl + "/" + this.tenantId + "/flows/import", formData, {
          headers: formData.getHeaders,
          withCredentials: true,
        })
        .then(() => {
          this.closeImportFlow();
          this.resetDialog();
          this.$emit(
            "activateSnackbar",
            true,
            this.$t("strings.import-flow-text"),
          );
          this.refreshList();
        })
        .catch((error) => {
          if (error.response.data.status === 409) {
            this.activateDependencies(
              true,
              JSON.parse(JSON.stringify(error.response.data)),
            );
          } else {
            this.setError(error, false);
          }
        });
    },
    activateDependencies(status, list) {
      this.dependenciesList = list;
      this.dialogDependencies = status;
    },
  },
};
</script>
